import { useMutation, useQueryClient } from '@tanstack/react-query';
import { promotionsService } from '../services/promotions.service';
import type { CreatePromotionData } from '../types/promotions.types';

export function useCreatePromotion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePromotionData) => promotionsService.createPromotion(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['promotions'] });
    },
  });
}
